import { css } from 'styled-components';

import { FontBase, StatusLead, StatusLeadFromBe, StatusTypes } from 'const';
import theme from 'ui/theme';

export const pxToRem = size => {
  let checksize;
  if (typeof size === 'number') {
    checksize = size;
  } else if (typeof size === 'string') {
    const len = size.indexOf('px') === -1 ? size.length : size.indexOf('px');
    checksize = parseInt(size.substr(0, len), 10);
  } else {
    checksize = FontBase;
  }

  const remSize = checksize / FontBase;
  return `${remSize}rem`;
};

export const StatusColor = status => {
  let style;
  switch (status) {
    case 'Inactive':
    case 'download':
    case 'DownloadFailed':
      style = css`
        background-color: ${theme().colors.semantic.redBg};
        color: ${theme().colors.semantic.secondary};
      `;
      break;
    case 'InProgress':
    case 'Charging':
    case StatusLead.NEW:
      style = css`
        background-color: ${theme().colors.blue.four};
        color: ${theme().colors.blue.one};
      `;
      break;
    case 'Preparing':
    case StatusTypes.PENDING:
    case StatusLead.FOLLOW_UP:
    case StatusLead.COMMERCIAL_CALL:
    case StatusLead.TECHNICAL_CALL:
    case StatusLead.QUOTATION:
    case StatusLeadFromBe.FOLLOW_UP:
      style = css`
        background-color: ${theme().colors.lightViolet};
        color: ${theme().colors.violet};
      `;
      break;
    case 'Faulted':
      style = css`
        background-color: ${theme().colors.semantic.redBg};
        color: ${theme().colors.semantic.secondary};
      `;
      break;

    case null:
      style = css`
        background-color: unset;
        color: unset;
      `;
      break;
    case StatusTypes.ENABLED:
    case 'Available':
    case 'Installed':
    case StatusLead.CONVERTIBLE:
    case StatusTypes.SOLVED:
    case StatusLead.INTERESTED:
      style = css`
        background-color: ${theme().colors.statusBgGreen};
        color: ${theme().colors.statusText};
      `;
      break;
    case StatusTypes.DISABLED:
    case 'Unavailable':
    case 'Disconnected':
    default:
      style = css`
        background-color: ${theme().colors.status.greyBg};
        color: ${theme().colors.darkGray};
      `;
      break;
  }

  return style;
};
